import { builder } from '@builder.io/react';

import { NextApiRequest, NextApiResponse } from 'next';

export const MIN_YEAR = 2006;
export const MAX_YEAR = new Date().getFullYear();

const splitString = (str: string) => (str ? str.split(', ') : '');

export default async function openDataset(req: NextApiRequest, res: NextApiResponse) {
  try {
    const min = req.query?.minYear ?? MIN_YEAR.toString();
    const maxYearQuery = req.query?.maxYear ?? MAX_YEAR.toString();
    const max = typeof maxYearQuery === 'string' && parseInt(maxYearQuery).toString(); // plus one for fetching purpouses
    const search = (req.query.s as string) ?? '';
    const dataProvided = req.query.data as string;
    const dataProvidedArray = splitString(dataProvided);
    const diversity = req.query.diversity as string;
    const diversityArray = splitString(diversity);
    const annotation = req.query.annotation as string;
    const annotationArray = splitString(annotation);
    const newMinYear = new Date(`${Number(min)}-01-01T00:00:01`);
    const newMaxYear = new Date(`${Number(max)}-12-31`);

    const sets = await builder.getAll('open-dataset', {
      options: { noTargeting: true },
      omit: 'data.blocks',
      limit: 200,
      query: {
        data: {
          date: { $gte: newMinYear, $lte: newMaxYear },
          title: { $regex: search, $options: 'i' },
          annotation: { $regex: annotationArray && annotationArray.join('|'), $options: 'i' },
          diversity: { $regex: diversityArray && diversityArray.join('|'), $options: 'i' },
          dataProvided: { $regex: dataProvidedArray && dataProvidedArray.join('|'), $options: 'i' }
        }
      }
    });

    const formattedJsonResults = sets.map(dataset => {
      return {
        id: dataset.id,
        annotation: dataset.data.annotation,
        date: dataset.data.date,
        time: dataset.data.time,
        diversity: dataset.data.diversity,
        link: dataset.data.link,
        location: dataset.data.location,
        logoBack: {
          url: dataset.data.logoBack,
          alt: `${dataset.data.title} logo back`
        },
        logoFront: {
          url: dataset.data.logoFront,
          alt: `${dataset.data.title} logo front`
        },
        provider: dataset.data.provider,
        slug: dataset.data.slug,
        title: dataset.data.title,
        traffic: dataset.data.traffic,
        dataProvided: dataset.data.dataProvided,
        nucleusLink: dataset.data.nucleusLink
      };
    });

    res.json(formattedJsonResults);
  } catch (err) {
    res.status(500).send({ error: 'Failed to fetch data' });
  }
}
